






















import theme from '@zk/theme/lib/variables.scss';
import DrawerContent from './DrawerContent.vue';

import { useLayoutListener } from './LayoutListener';
import { useFieldLayout } from '../store';

import {
  defineComponent,
  computed,
  toRef,
  getCurrentInstance
} from '@vue/composition-api';
import { filterDownComponent } from '@zk/framework-vue';

export default defineComponent({
  name: 'LayoutDrawerRoot',
  components: { DrawerContent },
  setup() {
    const store = useFieldLayout();
    // 监听事件
    useLayoutListener({
      showDrawer: store.showDrawer
    });

    const vm = getCurrentInstance()!.proxy;
    const show = computed({
      get: () => store.drawerVisible,
      set: () => store.closeDrawer()
    });
    store.onClose(() => {
      store.onClearLayout();
    });
    const drawerSize = computed(() => 'calc(100% - 50px)');

    const onBeforeClose = (done: () => void) => {
      console.log('layout onBeforeClose');
      done();
    };
    const onOpened = () => {
      const areas = filterDownComponent(vm, 'TheLayoutArea');
      (areas as any)?.forEach((area: any) => area.doUpdateLayout?.());

      if (store.action?.autoAddField) {
        // 自动打开添加字段弹窗
        store.openFieldDialog('add');
      } 
    };

    return {
      store,
      show,
      drawerSize,
      onBeforeClose,
      loading: toRef(store, 'layoutLoading'),
      onOpened
    };
  },
  data() {
    return {
      bemNS: theme.bemNS
    };
  }
});
